import { useEffect } from 'react';

import createEmailTemplate from './create_email_template';
import { isEditorEmpty } from 'components/text_editor/helpers';
import { useAnswers } from 'components/text_editor/plugins/answers';
import { useVariables } from 'components/composer/contexts/variables_context';

export default function useEmailTemplateAndAnswers({ editorRef, onChange, value }, defaultBody) {
  const variables = useVariables();

  const editor = editorRef.current;
  useEffect(() => {
    if (editor && isEditorEmpty(editor.value)) {
      const { selection } = createEmailTemplate(editor, defaultBody, variables);
      if (selection) {
        editor.select(selection);
      }
      onChange(editor);
    }
  }, [editor]);

  useAnswers(editor, onChange);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/email/use_email_template.js